module.exports = __webpack_public_path__ + "assets/img/collect-cards-light3.0dd926b7.png";